import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

export class SetService {
    static readonly type = '[ModifyServiceState] SetService';
    constructor(public service: any) { }
}

export class ResetService {
    static readonly type = '[ModifyServiceState] ResetService';
}

export interface ModifyServiceStateModel {
    service: any;
}

@State<ModifyServiceStateModel>({
    name: 'modifyService',
    defaults: {
        service: null,
    }
})
@Injectable()
export class ModifyServiceState {

    @Selector()
    static service(state: ModifyServiceStateModel) {
        return state.service;
    }

    @Action(SetService)
    setService(ctx: StateContext<ModifyServiceStateModel>, action: SetService) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            service: action.service
        });
    }

    @Action(ResetService)
    resetService(ctx: StateContext<ModifyServiceStateModel>) {
        const state = ctx.getState();
        ctx.setState({
            ...state,
            service: null
        });
    }

}